import axios from "axios";
import { ServerPath } from "../Constant/index";
// import { useNavigate } from "react-router-dom";
// import { useQueryClient } from "@tanstack/react-query";

let url = `${ServerPath}`;

if (process.env.NODE_ENV === "production") {
  // TODO: Set production API URL
  url = `${ServerPath}/api`;
}

export const _axios = axios.create({ baseURL: url });

_axios.interceptors.request.use(
  (request) => {
    // Get the token from localStorage
    console.log("this is the jwt token", localStorage.getItem("Token"))
    const token = localStorage.getItem("Token");
    console.log("this is the jwt token", token);
    request.headers.Authorization = localStorage.getItem("Token") || "";
    return request;
  },
  (error) => Promise.reject(error)
);

// Uncomment this section if you need response interceptors
// _axios.interceptors.response.use(
//   (response) => {
//     if (response.data.success === 0 && response.data.message === 'Access Denied!') {
//       // const queryClient = useQueryClient(); // This would only work in a React component
//       // const navigate = useNavigate(); // This would only work in a React component
//       // queryClient.clear();
//       // localStorage.clear();
//       // navigate("/onboarding/login");
//     }
//     return response;
//   },
//   (error) => Promise.reject(error)
// );
